import { defineStore } from "pinia";
import Services from '@/services/educationCurrentDataServices'
import { mapEducationCurrentData } from '@/helpers/mapFuncs'

export const useEducationCurrentDataStore = defineStore("educationCurrentData", {

state:()=>({
    education: {},
    educations: [],
}),
getters : {
    getEducation() {
        return mapEducationCurrentData(this.education)
    },
    getEducations() {
        return this.educations.map(mapEducationCurrentData)
    },
},
actions : {
    /** Start Sets */
    setEducation(education) {
        this.education = education
    },
    setEducations(educations) {
        this.educations = educations.map(mapEducationCurrentData)
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setCurrentEducation(response.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setCurrentEducation(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setCurrentEducations(response.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.educations.push(response.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.educations[this.educations.findIndex((x)=>x.id == id)] = response.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.educations = this.educations.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});